import React from 'react';
import '../../../CSS/UI Components/NewProfessionalCard.css';
// import locationcolorIcon from '../../../../Assets/colorLocation.png'
import locationIcon from '../../../Assets/vector.png'

// import locationIcon from '../../../Assets/icon-location-on.png';
// import locationIcon from '../../../../New_Website_V2/Assets/icon-location-on.png'
const showPlusForTens = (num) => {
  if (num < 10) return num.toString();
  const base = Math.floor(num / 10) * 10;
  return `${base}+`;
};

const NewProfessionalCard = ({
  state,
  categoryName,
  proData,
  clickOnAtHome,
  onPressCard,
  serviceCount,
  fromServiceSearch,
  servicePriceCurrency,
  proArray,
  serviceName,
  isLast,
}) => {
  // console.log('Rendering Professional Card for:', proData);
  let rating =
    clickOnAtHome || proData.MERCHANT_PERSONNEL_STORE_TYPE === 'virtual'
      ? proData.MERCHANT_PERSONNEL_ATHOME_RATING
        ? Number(proData.MERCHANT_PERSONNEL_ATHOME_RATING).toFixed(1)
        : ''
      : proData.MERCHANT_PERSONNEL_RATING
      ? Number(proData.MERCHANT_PERSONNEL_RATING).toFixed(1)
      : '';

  return (
    <div className="npc-card" style={{ cursor: 'pointer' }} onClick={onPressCard}>
      <div style={{ position: 'relative' }}>
        <img
          src={proData.PROFESSIONAL_IMAGE || proData.image_link}
          alt={proData.MERCHANT_NAME}
          className="npc-card-image"
        />
        <div className="npc-rating-tag">
          <span className="npc-rating-text">
            {rating} <span style={{ color: '#92c63d', fontSize: 14 }}>★</span>
          </span>
        </div>
        <div className="npc-service-count-badge">
          <span className="npc-service-count-text">
            {showPlusForTens(serviceCount) + (serviceCount > 1 ? ' Services' : ' Service')}
          </span>
        </div>
      </div>
      <div className="npc-service-details">
        <div className="npc-card-title" title={proData.MERCHANT_NAME}>
          {proData.MERCHANT_NAME}
        </div>
        {/* {!(clickOnAtHome || proData.MERCHANT_PERSONNEL_STORE_TYPE === 'virtual') && ( */}
          <div className="npc-location-row">
            <img
              src={locationIcon}
              alt="location"
              style={{ marginRight: 4, width: 16, height: 16, verticalAlign: 'middle'}}
            />
            <span className="npc-location">
              {proData.MERCHANT_PERSONNEL_TIMEZONE === 'Asia/Kolkata' ||
              proData.SERVICE_TIMEZONE === 'Asia/Kolkata'
                ? (Number(proData.distance) / 1000).toFixed(2) + ' km away'
                : (Number(proData.distance) / 1609.344).toFixed(2) + ' mi away'}
              {' | '}
              {proData.MERCHANT_PERSONNEL_ADDRESS_LINE2}
            </span>
          </div>
        {/* )}  */}
        <div className="npc-line-style" />
        <div className="npc-card-bottom-row">
          <div>
            <span className="npc-card-service">
              {fromServiceSearch ? serviceName + ' ' : 'Starting at just'}
            </span>
            <span className="npc-price">
              {servicePriceCurrency}
              {fromServiceSearch ? proData.SERVICE_OFFER_PRICE : proData.SERVICE_PRICE_MIN}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewProfessionalCard;